export default __webpack_public_path__ + "static/media/pattern_star.e074d06f.png";